import React from "react";
import {
  Building2,
  ClipboardCheck,
  HeartHandshake,
  Mail,
  Target,
} from "lucide-react";
import "./About.css";

const pillars = [
  {
    number: "01",
    title: "Training",
    description:
      "Examines how primary health care is embedded in learning, teaching practice, and workforce preparation.",
  },
  {
    number: "02",
    title: "Research",
    description:
      "Reviews the systems and output that turn evidence into stronger primary health care practice.",
  },
  {
    number: "03",
    title: "Community engagement",
    description:
      "Considers partnerships, service learning, and the institution's contribution to community health.",
  },
];

export default function AboutPage() {
  return (
    <div className="about-page">
      <section className="about-hero" aria-labelledby="about-title">
        <div className="about-hero-icon" aria-hidden="true">
          <Building2 size={28} />
        </div>
        <div>
          <span className="about-eyebrow">Mulu Health PLC</span>
          <h1 id="about-title">About the AHC PHC Capacity Assessment Tool</h1>
          <p>
            A structured digital workbook for assessing and strengthening
            primary health care capacity within higher education institutions.
          </p>
        </div>
      </section>

      <section className="about-intro" aria-labelledby="purpose-title">
        <div className="about-section-heading">
          <Target size={22} aria-hidden="true" />
          <div>
            <span className="about-eyebrow">Our purpose</span>
            <h2 id="purpose-title">
              Turning assessment into practical improvement
            </h2>
          </div>
        </div>
        <p>
          The tool helps institutions identify strengths, priorities, and
          opportunities for improvement across the elements that support quality
          primary health care education, research, and community partnership. It
          provides a consistent framework for documenting findings and producing
          clear, evidence-based reports.
        </p>
      </section>

      <section aria-labelledby="pillars-title">
        <div className="about-section-heading about-pillars-heading">
          <ClipboardCheck size={22} aria-hidden="true" />
          <div>
            <span className="about-eyebrow">Assessment framework</span>
            <h2 id="pillars-title">Three connected pillars</h2>
          </div>
        </div>
        <div className="about-pillars">
          {pillars.map((pillar) => (
            <article className="about-pillar" key={pillar.number}>
              <span className="about-pillar-number">{pillar.number}</span>
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-contact" aria-labelledby="contact-title">
        <HeartHandshake size={25} aria-hidden="true" />
        <div>
          <h2 id="contact-title">Work with us</h2>
          <p>
            For support, feedback, or partnership enquiries, contact Mulu Health
            PLC.
          </p>
        </div>
        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=muluhealth@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
          className="about-contact-link"
        >
          <Mail size={17} aria-hidden="true" />
          muluhealth@gmail.com
        </a>
      </section>
    </div>
  );
}
